export default __webpack_public_path__ + "static/media/generic_product_image.3da99173.png";